<template>
  <div class="ca-bullet-container">
    <div class="poc-page">
      <!-- ═══════════════════════════════════════════════════════════════════
           GRID
      ════════════════════════════════════════════════════════════════════ -->
      <h1 class="poc-heading-1">Design System PoC</h1>

      <h2 class="poc-heading-2">Grid</h2>

      <div class="ca-row poc-grid-row">
        <div class="ca-col-4 ca-col-sm-12">
          <div class="ca-bg-green ca-text-white poc-grid-cell">
            col-12 (Full width)
          </div>
        </div>
      </div>
      <div class="ca-row poc-grid-row">
        <div class="ca-col-4 ca-col-sm-6">
          <div class="ca-bg-green ca-text-white poc-grid-cell">col-6</div>
        </div>
        <div class="ca-col-4 ca-col-sm-6">
          <div class="ca-bg-jet-green ca-text-white poc-grid-cell">col-6</div>
        </div>
      </div>
      <div class="ca-row poc-grid-row">
        <div class="ca-col-4 ca-col-sm-4" v-for="i in 3" :key="'c4-' + i">
          <div
            class="ca-text-white poc-grid-cell"
            :class="i % 2 !== 0 ? 'ca-bg-green' : 'ca-bg-jet-green'"
          >
            col-4
          </div>
        </div>
      </div>
      <div class="ca-row poc-grid-row">
        <div class="ca-col-4 ca-col-sm-3" v-for="i in 4" :key="'c3-' + i">
          <div
            class="ca-text-white poc-grid-cell"
            :class="i % 2 === 0 ? 'ca-bg-jet-green' : 'ca-bg-green'"
          >
            col-3
          </div>
        </div>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════════
           CHIPS
      ════════════════════════════════════════════════════════════════════ -->
      <h2 class="poc-heading-2">Chips / Pills</h2>

      <div class="poc-section">
        <h3 class="poc-heading-3">Variantes base</h3>
        <div class="poc-row">
          <CaChip variant="outline">Outline</CaChip>
          <CaChip variant="filled">Filled</CaChip>
          <CaChip variant="outline" color-scheme="secondary"
            >Secondary outline</CaChip
          >
          <CaChip variant="outline" shadow>Com sombra</CaChip>
        </div>

        <h3 class="poc-heading-3">Com ícone e badge</h3>
        <div class="poc-row">
          <CaChip variant="outline">
            <template #icon>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.35-4.35" />
              </svg>
            </template>
            Com ícone
          </CaChip>
          <CaChip variant="filled">
            Pesquisado
            <template #badge>12</template>
          </CaChip>
          <CaChip variant="outline">
            <template #icon>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                />
              </svg>
            </template>
            Com badge
            <template #badge>5</template>
          </CaChip>
        </div>

        <h3 class="poc-heading-3">Icon-only e estados</h3>
        <div class="poc-row">
          <CaChip variant="outline" icon-only>
            <template #icon>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.35-4.35" />
              </svg>
            </template>
          </CaChip>
          <CaChip variant="filled" icon-only>
            <template #icon>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
            </template>
          </CaChip>
          <CaChip variant="outline" :disabled="true">Disabled</CaChip>
          <CaChip variant="filled" :loading="true">Loading</CaChip>
        </div>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════════
           BUTTONS — GENERAL PURPOSE
      ════════════════════════════════════════════════════════════════════ -->
      <h2 class="poc-heading-2">Botões — Uso geral</h2>

      <div class="poc-section">
        <h3 class="poc-heading-3">Primary</h3>
        <div class="poc-row">
          <CaButton type="primary">Confirmar</CaButton>
          <CaButton type="primary" scheme="danger">Eliminar</CaButton>
          <CaButton type="primary" scheme="inverted" class="poc-dark-bg"
            >Inverted</CaButton
          >
          <CaButton type="primary" :disabled="true">Disabled</CaButton>
        </div>

        <h3 class="poc-heading-3">Secondary</h3>
        <div class="poc-row">
          <CaButton type="secondary">Secundário</CaButton>
          <CaButton type="secondary" scheme="danger">Perigo</CaButton>
          <CaButton type="secondary" scheme="inverted" class="poc-dark-bg"
            >Inverted</CaButton
          >
          <CaButton type="secondary" :disabled="true">Disabled</CaButton>
        </div>

        <h3 class="poc-heading-3">Tertiary</h3>
        <div class="poc-row">
          <CaButton type="tertiary">Ver mais</CaButton>
          <CaButton type="tertiary" scheme="danger">Remover</CaButton>
          <CaButton type="tertiary" scheme="inverted" class="poc-dark-bg"
            >Inverted</CaButton
          >
          <CaButton type="tertiary" :disabled="true">Disabled</CaButton>
        </div>

        <h3 class="poc-heading-3">Com ícones</h3>
        <div class="poc-row">
          <CaButton type="primary">
            <template #icon-left>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
            </template>
            Ícone esquerda
          </CaButton>
          <CaButton type="secondary">
            Ícone direita
            <template #icon-right>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </template>
          </CaButton>
          <CaButton type="primary" icon-only title="Adicionar">
            <template #icon-left>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
            </template>
          </CaButton>
          <CaButton type="secondary" icon-only title="Pesquisar">
            <template #icon-left>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.35-4.35" />
              </svg>
            </template>
          </CaButton>
        </div>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════════
           BUTTONS — NAV / MENU
      ════════════════════════════════════════════════════════════════════ -->
      <h2 class="poc-heading-2">Botões — Navbar / Menu</h2>

      <div class="poc-section">
        <h3 class="poc-heading-3">Nav (40px, 14px, medium)</h3>
        <div class="poc-row poc-row--col">
          <CaButton variant="nav">Item de navegação</CaButton>
          <CaButton variant="nav">
            <template #icon-left>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              </svg>
            </template>
            Com ícone
          </CaButton>
          <CaButton variant="nav" :disabled="true">Disabled</CaButton>
        </div>

        <h3 class="poc-heading-3">Section header (48px, 16px, semibold)</h3>
        <div class="poc-row poc-row--col">
          <CaButton variant="section">Secção principal</CaButton>
          <CaButton variant="section" :icon-right="true">
            Ver tudo
            <template #icon-right>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </template>
          </CaButton>
        </div>

        <h3 class="poc-heading-3">Tertiary nav (item de navbar)</h3>
        <div class="poc-row">
          <CaButton variant="tertiary">Contas</CaButton>
          <CaButton variant="tertiary" :current="true">Poupança</CaButton>
          <CaButton variant="tertiary" :icon-right="true">
            Investimentos
            <template #icon-right>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </template>
          </CaButton>
        </div>

        <h3 class="poc-heading-3">Secondary-nav (Voltar)</h3>
        <div class="poc-row">
          <CaButton variant="secondary-nav">
            <template #icon-left>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </template>
            Voltar
          </CaButton>
          <CaButton variant="secondary-nav" :disabled="true">
            <template #icon-left>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </template>
            Disabled
          </CaButton>
        </div>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════════
           LINK BUTTONS
      ════════════════════════════════════════════════════════════════════ -->
      <h2 class="poc-heading-2">Link Buttons</h2>

      <div class="poc-section">
        <h3 class="poc-heading-3">Action (semibold, verde)</h3>
        <div class="poc-row poc-row--col" style="max-width: 320px">
          <CaLinkButton type="action" href="#">Contas à ordem</CaLinkButton>
          <CaLinkButton type="action" href="#"
            >Poupança e investimento</CaLinkButton
          >
          <CaLinkButton type="action" href="#" :disabled="true"
            >Disabled</CaLinkButton
          >
        </div>

        <h3 class="poc-heading-3">List item (regular, cinzento)</h3>
        <div class="poc-row poc-row--col" style="max-width: 320px">
          <CaLinkButton type="list" href="#">Conta CA Digital</CaLinkButton>
          <CaLinkButton type="list" href="#"
            >Transferências imediatas</CaLinkButton
          >
          <CaLinkButton type="list" href="#" :badge-new="true"
            >Novidade recente</CaLinkButton
          >
        </div>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════════
           FORM ELEMENTS
      ════════════════════════════════════════════════════════════════════ -->
      <h2 class="poc-heading-2">Formulários</h2>

      <div class="poc-section">
        <div class="poc-form-grid">
          <!-- Input -->
          <CaFormGroup
            label="Input base"
            label-for="inp-base"
            hint="Texto de ajuda opcional"
          >
            <CaInput
              id="inp-base"
              v-model="formDemo.name"
              placeholder="ex: João Silva"
            />
          </CaFormGroup>

          <CaFormGroup
            label="Input erro"
            label-for="inp-error"
            error="Campo obrigatório"
          >
            <CaInput
              id="inp-error"
              v-model="formDemo.email"
              status="error"
              placeholder="email@exemplo.pt"
            />
          </CaFormGroup>

          <CaFormGroup label="Input sucesso" label-for="inp-success">
            <CaInput
              id="inp-success"
              v-model="formDemo.success"
              status="success"
              placeholder="Válido"
            />
          </CaFormGroup>

          <CaFormGroup label="Input disabled" label-for="inp-dis">
            <CaInput
              id="inp-dis"
              :model-value="'Valor bloqueado'"
              :disabled="true"
            />
          </CaFormGroup>

          <!-- Select -->
          <CaFormGroup label="Select" label-for="sel-base">
            <CaSelect
              id="sel-base"
              v-model="formDemo.select"
              :options="[
                { value: 'conta-ordem', label: 'Conta à ordem' },
                { value: 'poupanca', label: 'Poupança' },
                { value: 'investimento', label: 'Investimento' },
              ]"
            />
          </CaFormGroup>

          <CaFormGroup
            label="Select erro"
            label-for="sel-err"
            error="Selecione uma opção"
          >
            <CaSelect
              id="sel-err"
              v-model="formDemo.selectErr"
              status="error"
              :options="[{ value: 'a', label: 'Opção A' }]"
            />
          </CaFormGroup>
        </div>

        <!-- Checkboxes -->
        <h3 class="poc-heading-3">Checkboxes</h3>
        <div class="poc-row poc-row--col">
          <CaCheckbox
            id="chk-1"
            v-model="formDemo.chk1"
            label="Aceito os termos e condições"
          />
          <CaCheckbox
            id="chk-2"
            v-model="formDemo.chk2"
            label="Receber comunicações de marketing"
          />
          <CaCheckbox
            id="chk-dis"
            :model-value="true"
            :disabled="true"
            label="Opção desativada (marcada)"
          />
        </div>

        <!-- Radios -->
        <h3 class="poc-heading-3">Radio buttons</h3>
        <div class="poc-row poc-row--col">
          <CaRadio
            id="rd-1"
            name="conta"
            value="ordem"
            v-model="formDemo.radio"
            label="Conta à ordem"
          />
          <CaRadio
            id="rd-2"
            name="conta"
            value="poupanca"
            v-model="formDemo.radio"
            label="Poupança"
          />
          <CaRadio
            id="rd-3"
            name="conta"
            value="invest"
            v-model="formDemo.radio"
            label="Investimento"
          />
          <CaRadio
            id="rd-dis"
            name="conta-dis"
            value="x"
            :disabled="true"
            label="Desativado"
          />
        </div>

        <!-- FormGroup required -->
        <h3 class="poc-heading-3">FormGroup obrigatório</h3>
        <div style="max-width: 320px">
          <CaFormGroup
            label="NIF"
            label-for="nif"
            :required="true"
            hint="9 dígitos sem espaços"
          >
            <CaInput id="nif" v-model="formDemo.nif" placeholder="123456789" />
          </CaFormGroup>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import CaChip from "./base/tags/CaChip.vue";
import CaInput from "./base/forms/CaInput.vue";
import CaSelect from "./base/forms/CaSelect.vue";
import CaCheckbox from "./base/forms/CaCheckbox.vue";
import CaRadio from "./base/forms/CaRadio.vue";
import CaFormGroup from "./base/forms/CaFormGroup.vue";

const formDemo = ref({
  name: "",
  email: "",
  success: "exemplo@ca.pt",
  select: "",
  selectErr: "",
  chk1: false,
  chk2: true,
  radio: "ordem",
  nif: "",
});
</script>

<style scoped lang="scss">
.poc-page {
  padding: var(--padding-5) 0 var(--padding-12);
}

.poc-heading-1 {
  font-size: 32px;
  font-weight: 700;
  color: var(--ca-color-theme-primary);
  margin: 0 0 var(--padding-5);
}

.poc-heading-2 {
  font-size: 22px;
  font-weight: 700;
  color: var(--ca-color-theme-primary);
  margin: 48px 0 var(--padding-4);
  padding-bottom: var(--padding-3);
  border-bottom: 2px solid var(--ca-jet-green);
}

.poc-heading-3 {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--ca-color-text-body-variant);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin: var(--padding-4) 0 var(--padding-3);
}

.poc-section {
  background: var(--ca-solarized);
  border-radius: var(--radius-3);
  padding: var(--padding-5);
}

.poc-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--size-3);

  &--col {
    flex-direction: column;
    align-items: flex-start;
  }
}

.poc-dark-bg {
  background-color: var(--ca-color-theme-primary) !important;
  padding: var(--size-3) var(--size-4);
  border-radius: var(--radius-2);
}

.poc-form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: var(--size-5);
  margin-bottom: var(--padding-5);
}

// Grid demo cells (kept from original)
.poc-grid-row {
  margin-bottom: var(--padding-4);
}

.poc-grid-cell {
  border-radius: var(--radius-4);
  padding: var(--padding-5) var(--padding-4);
  text-align: center;
  font-weight: 700;
  font-size: var(--font-size-xs);
}
</style>
